import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestRejectReturn } from "./rejectReturn.request";

const useRejectReturn = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestRejectReturn,
    onError: toastServerError,
    ...options
  });
};

export default useRejectReturn;
